import { Stack, styled } from "@mui/material";
import { toolbarBrandingName } from "../classes.js";
const excludedProps = ["as", "cssVariables", "ownerState", "sx", "theme"];
const Root = styled(Stack, {
  name: toolbarBrandingName,
  overridesResolver: (_props, styles) => [styles.root],
  shouldForwardProp: (prop) => !excludedProps.includes(prop),
  slot: "Root"
})(({ cssVariables: vars }) => ({
  alignItems: "center",
  backgroundColor: vars.brandingBackgroundColor,
  color: vars.brandingColor,
  flex: "0 0 auto",
  height: vars.brandingHeight,
  overflow: "hidden",
  width: "100%"
}));
export {
  Root
};
//# sourceMappingURL=Root.js.map
